import { render, staticRenderFns } from "./authAgreement.vue?vue&type=template&id=4d7c0c60&scoped=true&"
import script from "./authAgreement.vue?vue&type=script&lang=js&"
export * from "./authAgreement.vue?vue&type=script&lang=js&"
import style0 from "./authAgreement.vue?vue&type=style&index=0&id=4d7c0c60&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7c0c60",
  null
  
)

export default component.exports